var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.918945 3.43678C0.918945 2.25345 1.87845 1.29395 3.06178 1.29395H28.7758C29.9591 1.29395 30.9186 2.25345 30.9186 3.43678V19.1511C30.9186 20.3344 29.9591 21.2939 28.7758 21.2939H3.06178C1.87845 21.2939 0.918945 20.3344 0.918945 19.1511V3.43678ZM3.06178 2.72267C2.66741 2.72267 2.34742 3.04242 2.34742 3.43678V19.1511C2.34742 19.5455 2.66741 19.8655 3.06178 19.8655H28.7758C29.1702 19.8655 29.4902 19.5455 29.4902 19.1511V3.43678C29.4902 3.04241 29.1702 2.72267 28.7758 2.72267H3.06178Z",
    fill: "#0AA8E3",
    stroke: "#0AA8E3",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5151 12.5987L1.9436 3.31284L2.75053 2.13379L15.9186 11.1435L29.0866 2.13379L29.8933 3.31284L16.3218 12.5987C16.0786 12.7649 15.7583 12.7649 15.5151 12.5987Z",
    fill: "#0AA8E3",
    stroke: "#0AA8E3",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendEmail);
export default __webpack_public_path__ + "static/media/ic-send-email.3fd3b867317c65dda24acbcf39de773b.svg";
export { ForwardRef as ReactComponent };